import { FormTypes } from '@oneblink/types'

import makeIsShowing from '../../is-element-showing'
import {
  replaceElementOptions,
  createElementOptions,
} from '../../definition-manipulation'
import {
  findPerson,
  generateName,
  getContactEmails,
  getContactNames,
  getContactPhones,
  getOtherPerson,
  getPeople,
  PeopleLike,
  setToSortedArray,
} from '../common/contacts'

function getEmergencyPerson(
  submission: Record<string, unknown>,
  definition: FormTypes.Form,
) {
  return getOtherPerson(
    {
      First_Name: 'Emergency_First_Name',
      Last_Name: 'Emergency_Last_Name',
    },
    submission,
    definition.elements,
  )
}

export function populateContactElements(
  liveSubmission: Record<string, unknown>,
  definition: FormTypes.Form,
) {
  const contactNames = getContactNames(liveSubmission, definition.elements)

  replaceElementOptions(
    definition,
    'Emergency_Contact',
    createElementOptions(setToSortedArray(contactNames)),
  )

  const emergencyContact = getEmergencyPerson(liveSubmission, definition)

  if (emergencyContact) {
    contactNames.add(generateName(emergencyContact))
  }

  replaceElementOptions(
    definition,
    'personCompletingThisFormAndProvidingCertificationS',
    createElementOptions(setToSortedArray(contactNames)),
  )

  replaceElementOptions(
    definition,
    'Main_Email',
    createElementOptions(
      setToSortedArray(getContactEmails(liveSubmission, definition.elements)),
    ),
  )

  replaceElementOptions(
    definition,
    'Main_Phone',
    createElementOptions(
      setToSortedArray(getContactPhones(liveSubmission, definition.elements)),
    ),
  )

  return definition
}

export function personCompletingFormDetails(
  submission: Record<string, unknown>,
  definition: FormTypes.Form,
) {
  const personSelected =
    submission.personCompletingThisFormAndProvidingCertificationS

  if (typeof personSelected === 'string' && personSelected !== 'Other') {
    const people = getPeople(
      submission,
      definition.elements,
    ) as Partial<PeopleLike>[]
    const emergencyPerson = getEmergencyPerson(submission, definition)
    if (emergencyPerson) {
      people.push(emergencyPerson)
    }
    const personCompleting = findPerson(personSelected, people)

    submission.Title_Authorised__hidden = personCompleting?.Title
    submission.First_Name_Authorised__hidden = personCompleting?.First_Name
    submission.Last_name_Authorised__hidden = personCompleting?.Last_Name
    submission.Phone_Authorised__hidden = personCompleting?.Phone
    submission.Email_Authorised__hidden =
      personCompleting?.Email !== 'Other'
        ? personCompleting?.Email
        : personCompleting?.Other_email
  } else {
    submission.Title_Authorised__hidden = submission.Title_Authorised
    submission.First_Name_Authorised__hidden = submission.First_Name_Authorised
    submission.Last_name_Authorised__hidden = submission.Last_name_Authorised
    submission.Phone_Authorised__hidden = submission.Phone_Authorised
    submission.Email_Authorised__hidden = submission.Email_Authorised
  }
}

export function emergencyContact(
  submission: Record<string, unknown>,
  definition: FormTypes.Form,
) {
  const personSelected = submission?.Emergency_Contact
  const isShowing = makeIsShowing(submission, definition.elements)
  if (typeof personSelected === 'string' && personSelected !== 'Other') {
    const people = getPeople(submission, definition.elements)
    const person = findPerson(personSelected, people)
    submission.Emergency_First_Name__hidden = person?.First_Name
    submission.Emergency_Last_Name__hidden = person?.Last_Name
    submission.Emergency_Mobile__hidden =
      submission.emergencyContactNumberIsMobile
        ? person?.Phone
        : submission.Emergency_Mobile
  } else {
    submission.Emergency_First_Name__hidden = submission.Emergency_First_Name
    submission.Emergency_Last_Name__hidden = submission.Emergency_Last_Name
    if (isShowing('Emergency_Mobile')) {
      submission.Emergency_Mobile__hidden = submission.Emergency_Mobile
    }
  }
}

export function updateEmergencyContactIsMobile(
  submission: Record<string, unknown>,
  definition: FormTypes.Form,
) {
  let emergencyContactNumberIsMobile = false
  const selectedEmergencyContactName = submission.Emergency_Contact
  if (
    selectedEmergencyContactName &&
    typeof selectedEmergencyContactName === 'string'
  ) {
    const people = getPeople(submission, definition.elements)
    const emergencyContact = findPerson(selectedEmergencyContactName, people)
    if (emergencyContact && emergencyContact.Phone) {
      emergencyContactNumberIsMobile = emergencyContact.Phone.startsWith('04')
    }
  }

  submission.emergencyContactNumberIsMobile = emergencyContactNumberIsMobile
}
